import { useMemo, useState } from "react";
import Card, { Bar } from "./Card.jsx";
import Ball from "../Ball.jsx";
import { getFrequency, topByCount, bottomByCount } from "../../lib/lotto.js";

export default function Frequency({ rows }) {
  const [scope, setScope] = useState("all"); // "all" | "100" | "52"
  const weeks = scope === "all" ? undefined : Number(scope);
  const freq = useMemo(() => getFrequency(rows, weeks), [rows, scope]);
  const max = Math.max(...freq.map((f) => f.count));
  const top = topByCount(freq, 8);
  const bottom = bottomByCount(freq, 8);

  return (
    <Card
      title="번호 출현 빈도"
      subtitle={scope === "all" ? "전체" : `최근 ${scope} 회차`}
      span={1}
    >
      <div className="controls" style={{ marginBottom: 8 }}>
        {[
          ["all", "전체"],
          ["100", "100회"],
          ["52", "52회"],
        ].map(([v, label]) => (
          <button
            key={v}
            onClick={() => setScope(v)}
            className={scope === v ? "active" : ""}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="grid-2">
        <div>
          <h4 className="muted">많이 나온 번호 TOP 8</h4>
          {top.map((f) => (
            <Bar
              key={f.num}
              value={f.count}
              max={max}
              label={<Ball n={f.num} />}
              highlight
            />
          ))}
        </div>
        <div>
          <h4 className="muted">적게 나온 번호 BOTTOM 8</h4>
          {bottom.map((f) => (
            <Bar
              key={f.num}
              value={f.count}
              max={max}
              label={<Ball n={f.num} />}
            />
          ))}
        </div>
      </div>
    </Card>
  );
}
